import { format } from "date-fns";
import { isoToLocalDate, localDateToIso } from "@/utils/dateUtils";

const tagCollator = new Intl.Collator("en", { sensitivity: "base", numeric: true });

export const TAG_SORT_ALPHABETICAL = "alphabetical";
export const TAG_SORT_CUSTOM = "custom";

export function sortTagDefs(tagDefs) {
  return [...(tagDefs || [])].sort(
    (a, b) => tagCollator.compare(a.label || "", b.label || "") || tagCollator.compare(a.key || "", b.key || "")
  );
}

export function orderTagDefs(tagDefs, sortOrder) {
  return sortOrder === TAG_SORT_CUSTOM ? [...(tagDefs || [])] : sortTagDefs(tagDefs);
}

export function filterUserTags(tags, tagDefs) {
  return (tags || []).filter((key) => {
    const def = tagDefs.find((d) => d.key === key);
    return def && !def.auto;
  });
}

export function tagFilterEmptyMessage(noun, selectedKeys, tagDefs, match) {
  if (!selectedKeys.length) return "";
  const labels = selectedKeys.map((key) => tagDefs.find((d) => d.key === key)?.label ?? key);
  if (labels.length === 1) return `No ${noun} tagged ${labels[0]}`;
  const any = match === "any";
  const lead = labels.length === 2 ? (any ? "either" : "both") : any ? "any of" : "all of";
  return `No ${noun} with ${lead}: ${labels.join(any ? " or " : " + ")}`;
}

export function tagDueDateFor(tagDueDates, key) {
  return (tagDueDates || []).find((entry) => entry.key === key)?.dueDate ?? null;
}

export function withTagDueDate(tagDueDates, key, dueDate) {
  const others = (tagDueDates || []).filter((entry) => entry.key !== key);
  return dueDate ? [...others, { key, dueDate }] : others;
}

export function formatTagDueDate(iso) {
  const date = isoToLocalDate(iso);
  if (!date) return "";
  return format(date, date.getFullYear() === new Date().getFullYear() ? "MMM d" : "MMM d, yyyy");
}

export function isTagDueDatePast(iso) {
  return !!iso && iso < localDateToIso(new Date());
}
